// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-header[data-v-1819afcb] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.header-part[data-v-1819afcb] {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
